import React from 'react';
import { Link } from 'react-router-dom';
import { Store, Truck, Package, MapPin, Clock, Shield, Handshake } from 'lucide-react';

const LivraisonPage = () => {
  return (
    <div className="min-h-screen bg-[#FDFAF4] pb-16">
      {/* Hero */}
      <section className="py-20 px-6 bg-[#FDFAF4] border-b border-[#B8922A]/20">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-xs uppercase tracking-[0.3em] text-[#B8922A] mb-4">
            Livraison & retrait
          </p>
          <h1
            className="text-5xl md:text-6xl font-light mb-6 text-[#5C2018]"
            style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}
            data-testid="livraison-title"
          >
            Récupérez vos parfums
            <br />en toute simplicité
          </h1>
          <p className="text-lg text-[#332724] font-light leading-relaxed">
            Trois options simples et flexibles pour profiter de votre commande, partout en France.
          </p>
        </div>
      </section>

      {/* Options */}
      <section className="py-20 px-6">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Retrait en boutique */}
          <div className="bg-white p-10 rounded-2xl border-2 border-[#1E7A6A] shadow-[0_8px_32px_rgba(92, 32, 24,0.08)]" data-testid="retrait-boutique">
            <div className="w-16 h-16 bg-[#1E7A6A]/10 rounded-full flex items-center justify-center mb-6">
              <Store className="text-[#1E7A6A]" size={32} />
            </div>
            <p className="text-xs uppercase tracking-[0.2em] text-[#1E7A6A] mb-2">
              Option recommandée
            </p>
            <h2
              className="text-3xl mb-4 text-[#5C2018]"
              style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}
            >
              Retrait en boutique
            </h2>
            <p className="text-[#332724] font-light mb-6 leading-relaxed">
              Venez chercher votre commande au cœur du Polygone de Béziers. C'est l'occasion
              parfaite pour découvrir d'autres fragrances, profiter d'une consultation
              olfactive et échanger avec notre équipe.
            </p>
            <ul className="space-y-3 mb-6 text-sm">
              <li className="flex gap-3">
                <Shield className="text-[#1E7A6A] flex-shrink-0" size={18} />
                <span className="text-[#332724]"><strong>Gratuit</strong> — Aucun frais</span>
              </li>
              <li className="flex gap-3">
                <Clock className="text-[#1E7A6A] flex-shrink-0" size={18} />
                <span className="text-[#332724]">Disponible <strong>sous 24h à 48h</strong> après commande</span>
              </li>
              <li className="flex gap-3">
                <Package className="text-[#1E7A6A] flex-shrink-0" size={18} />
                <span className="text-[#332724]">Idéal pour les <strong>recharges</strong> et l'abonnement mensuel</span>
              </li>
              <li className="flex gap-3">
                <MapPin className="text-[#1E7A6A] flex-shrink-0" size={18} />
                <span className="text-[#332724]">3 Carrefour de l'Hours, Niveau Écluses</span>
              </li>
            </ul>
            <Link
              to="/contact"
              className="inline-block btn-primary px-6 py-3 rounded-full text-sm uppercase tracking-[0.2em]"
            >
              Voir l'adresse
            </Link>
          </div>

          {/* Remise en mains propres - Montpellier */}
          <div className="bg-white p-10 rounded-2xl border border-[#B8922A]/40 shadow-[0_8px_32px_rgba(92, 32, 24,0.05)]" data-testid="remise-montpellier">
            <div className="w-16 h-16 bg-[#5C2018]/10 rounded-full flex items-center justify-center mb-6">
              <Handshake className="text-[#5C2018]" size={32} />
            </div>
            <p className="text-xs uppercase tracking-[0.2em] text-[#5C2018] mb-2">
              Région Montpellier
            </p>
            <h2
              className="text-3xl mb-4 text-[#5C2018]"
              style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}
            >
              Remise en
              <br />mains propres
            </h2>
            <p className="text-[#332724] font-light mb-6 leading-relaxed">
              Vous habitez à Montpellier ou dans ses environs ? Nous nous déplaçons pour
              vous remettre votre commande en mains propres, sur rendez-vous. Un service
              de proximité, simple et chaleureux.
            </p>
            <ul className="space-y-3 mb-6 text-sm">
              <li className="flex gap-3">
                <MapPin className="text-[#5C2018] flex-shrink-0" size={18} />
                <span className="text-[#332724]"><strong>Montpellier</strong> et communes alentours</span>
              </li>
              <li className="flex gap-3">
                <Clock className="text-[#5C2018] flex-shrink-0" size={18} />
                <span className="text-[#332724]"><strong>Sur rendez-vous</strong>, selon nos disponibilités</span>
              </li>
              <li className="flex gap-3">
                <Handshake className="text-[#5C2018] flex-shrink-0" size={18} />
                <span className="text-[#332724]">Échange direct, pratique pour les <strong>recharges</strong></span>
              </li>
              <li className="flex gap-3">
                <Shield className="text-[#5C2018] flex-shrink-0" size={18} />
                <span className="text-[#332724]">Tarif sur demande, selon votre commune</span>
              </li>
            </ul>
            <Link
              to="/contact"
              className="inline-block btn-primary px-6 py-3 rounded-full text-sm uppercase tracking-[0.2em]"
            >
              Prendre rendez-vous
            </Link>
          </div>

          {/* Livraison */}
          <div className="bg-white p-10 rounded-2xl border border-gold shadow-[0_8px_32px_rgba(92, 32, 24,0.05)]" data-testid="livraison-domicile">
            <div className="w-16 h-16 bg-[#B8922A]/10 rounded-full flex items-center justify-center mb-6">
              <Truck className="text-[#B8922A]" size={32} />
            </div>
            <p className="text-xs uppercase tracking-[0.2em] text-[#B8922A] mb-2">
              Sur demande
            </p>
            <h2
              className="text-3xl mb-4 text-[#5C2018]"
              style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}
            >
              Livraison à domicile
            </h2>
            <p className="text-[#332724] font-light mb-6 leading-relaxed">
              Vous habitez loin de Béziers ? Nous expédions également vos parfums partout en
              France. Contactez-nous pour organiser votre livraison.
            </p>
            <ul className="space-y-3 mb-6 text-sm">
              <li className="flex gap-3">
                <Truck className="text-[#B8922A] flex-shrink-0" size={18} />
                <span className="text-[#332724]">Livraison <strong>France métropolitaine</strong></span>
              </li>
              <li className="flex gap-3">
                <Clock className="text-[#B8922A] flex-shrink-0" size={18} />
                <span className="text-[#332724]">Délai estimé : <strong>3 à 5 jours ouvrés</strong></span>
              </li>
              <li className="flex gap-3">
                <Package className="text-[#B8922A] flex-shrink-0" size={18} />
                <span className="text-[#332724]">Emballage soigné, écrin Harmony inclus</span>
              </li>
              <li className="flex gap-3">
                <Shield className="text-[#B8922A] flex-shrink-0" size={18} />
                <span className="text-[#332724]">Tarif communiqué selon votre commande</span>
              </li>
            </ul>
            <Link
              to="/contact"
              className="inline-block btn-secondary px-6 py-3 rounded-full text-sm uppercase tracking-[0.2em]"
            >
              Nous contacter
            </Link>
          </div>
        </div>
      </section>

      {/* Infos pratiques */}
      <section className="py-16 px-6 bg-white">
        <div className="max-w-4xl mx-auto">
          <h2
            className="text-3xl text-center mb-12 text-[#5C2018]"
            style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}
          >
            Bon à savoir
          </h2>
          <div className="space-y-6">
            <div className="bg-[#FDFAF4] p-6 rounded-lg border-l-4 border-[#1E7A6A]">
              <h3 className="font-medium text-[#5C2018] mb-2">📦 Abonnement mensuel</h3>
              <p className="text-[#332724] font-light text-sm leading-relaxed">
                Votre flacon nomade de 10 ml est disponible en retrait gratuit en boutique
                chaque mois, ou expédié à domicile sur demande.
              </p>
            </div>
            <div className="bg-[#FDFAF4] p-6 rounded-lg border-l-4 border-[#B8922A]">
              <h3 className="font-medium text-[#5C2018] mb-2">♻ Recharges</h3>
              <p className="text-[#332724] font-light text-sm leading-relaxed">
                Le service de recharge se fait <strong>exclusivement en boutique</strong>, car
                il nécessite votre flacon Harmony. C'est aussi l'occasion d'un moment de
                conseil personnalisé.
              </p>
            </div>
            <div className="bg-[#FDFAF4] p-6 rounded-lg border-l-4 border-[#5C2018]">
              <h3 className="font-medium text-[#5C2018] mb-2">🎁 Coffrets cadeaux</h3>
              <p className="text-[#332724] font-light text-sm leading-relaxed">
                Pour les coffrets et cartes cadeaux, le retrait en boutique est gratuit. Pour
                un envoi direct au destinataire, contactez-nous : nous nous occupons de tout,
                emballage et mot personnalisé compris.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LivraisonPage;
